import type { AnyXYChartScale } from '../../types/xy-chart-internals.js';
import type { LineDatapoint } from '../../types/xy-chart.js';
import { getBandCenteredPoint } from '../../utils/get-band-centered-point.js';
import { getCenterDate } from '../../utils/get-center-date.js';
import {
  isCategoricalLineScale,
  isNumericalLineScale,
  isTimeLineScale,
} from '../../utils/type-guards.js';

const getAccessor = (accessorKeys: ['x0', 'x1'] | ['y0', 'y1']) => {
  return (scale: AnyXYChartScale, relAccessor?: (value: number) => number) => {
    return (datapoint: LineDatapoint) => {
      const args = {
        scale,
        v0: datapoint[accessorKeys[0]],
        v1: datapoint[accessorKeys[1]],
      };

      if (isNumericalLineScale(args)) {
        const { scale, v0 } = args;
        return scale(relAccessor ? relAccessor(v0) : v0);
      }

      if (isTimeLineScale(args)) {
        const value = getCenterDate(args.v0, args.v1);
        return args.scale(value);
      }

      if (isCategoricalLineScale(args)) {
        const { scale, v0 } = args;
        return getBandCenteredPoint(scale, v0);
      }

      throw Error('unknown Accessor value for Line series');
    };
  };
};
export const xAccessor = (
  scale: AnyXYChartScale,
  relAccessor?: (value: number) => number,
) => getAccessor(['x0', 'x1'])(scale, relAccessor);

export const yAccessor = (
  scale: AnyXYChartScale,
  relAccessor?: (value: number) => number,
) => getAccessor(['y0', 'y1'])(scale, relAccessor);
